import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    prev: 'Previous',
    next: 'Next',
    indicator: 'Message {index} of {total}',
    close: 'Close'
  },
  {
    ns: 'alert'
  }
)
